import { Trans } from "react-i18next";
import { UserPublishResultResponseStatus } from "@apis/generated/openapi";
import { type PublisherTab } from "./types";

export interface StatusBadgeProps {
  tab: PublisherTab;
  status?: UserPublishResultResponseStatus;
}

export const StatusBadge = (props: StatusBadgeProps) => {
  const { tab, status } = props;
  const isFailed = status === UserPublishResultResponseStatus.FAIL;

  if (tab === "published") {
    return (
      <span className="inline-flex h-[28px] items-center justify-center rounded-full bg-kds-success-soft px-[10px] text-[14px] font-medium leading-[16px] text-kds-success-fg">
        <Trans>Published</Trans>
      </span>
    );
  }

  if (isFailed) {
    return (
      <span className="inline-flex h-[28px] items-center justify-center rounded-full bg-kds-danger-soft px-[10px] text-[14px] font-medium leading-[16px] text-kds-danger-fg">
        <Trans>Publish Failed</Trans>
      </span>
    );
  }

  return (
    <span className="inline-flex h-[28px] items-center justify-center rounded-full bg-kds-accent-soft px-[10px] text-[14px] font-medium leading-[16px] text-kds-accent-fg">
      <Trans>Scheduled</Trans>
    </span>
  );
};
